import { getCollapsedGroups, isGrouped, areAllRowGroupsCollapsed } from './row-groups.tsx';
import { createSelectorHook } from './utils.tsx';

export const useCollapsedGroups = createSelectorHook(getCollapsedGroups);
export const useIsGrouped = createSelectorHook(isGrouped);

export const useAreAllRowGroupsCollapsed = createSelectorHook(areAllRowGroupsCollapsed);
